import { useState, useEffect } from 'react';
import styles from '@/styles/components/OfflineBanner.module.css';

export function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className={styles.banner} role="status" aria-live="polite">
      You're offline. Changes will sync when reconnected.
    </div>
  );
}
